import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { resetOrder } from '../actions/orderActions';
import { connect } from 'react-redux';
import { resetCoupon } from '../actions/discountActions';

const OrderReceived = ({ resetOrder, resetCoupon }: any) => {
  const location = useLocation();

  useEffect(() => {
    return () => {
      resetOrder();
      resetCoupon();
    };
  }, []);

  if (location.state === undefined) {
    return <Redirect to="/" />;
  }

  const locationState = location.state as any;

  let SubTotal;

  if (locationState.order.products) {
    SubTotal =
      Math.round(
        locationState.order.products
          .map((eachItem) => eachItem.productQuantity * eachItem.productPrice)
          .reduce((total, currentValue) => total + currentValue) * 100
      ) / 100;
  }

  let total = locationState.order.total / 100;

  let discount;

  if (locationState.order.coupon) {
    if (SubTotal >= locationState.order.coupon.minimumSpend) {
      if (locationState.order.coupon.isPercent) {
        discount = (SubTotal / 100) * locationState.order.coupon.amount;
      } else {
        discount = locationState.order.coupon.amount;
      }
    }
  }

  return (
    <div className="mx-3 my-5">
      <div>
        <Helmet>
          <title>Order Confirmed - Frozberries Victoria</title>
          <meta name="description" content="Order Confirmed - Frozberries Victoria" />
        </Helmet>
      </div>
      <div>
        <div className="text-center">
          <i className=" far fa-check-circle fa-5x" style={{ color: 'rgb(236,23,79)' }}></i>
        </div>
        <h1 className="text-center display-5 my-3" style={{ color: 'rgb(236,23,79)' }}>
          Thank You {locationState.order.firstName.toUpperCase()}!
        </h1>
      </div>

      <div>
        <p className="text-center" style={{ fontSize: '20px' }}>
          Your order is{' '}
          {locationState.order.orderStatus === 'Confirmed' ? 'confirmed' : 'being processed'}, and
          your order number is
          <span style={{ color: 'rgb(236,23,79)' }}>
            {' '}
            {locationState.order.orderid.toUpperCase()}.{' '}
          </span>
          You will soon receieve an email with your order details.
        </p>
      </div>
      <div>
        <Row className=" pt-3">
          <Col md="9" sm="12" className="mx-auto">
            <table className="table border ">
              <thead className="table-borderless">
                <tr>
                  <th scope="col">PRODUCT</th>
                  <th></th>
                  <th scope="col">QTY</th>
                  <th scope="col">PRICE</th>
                </tr>
              </thead>
              <tbody className="border">
                {locationState.order.products.map((item) => (
                  <tr key={item.productId}>
                    <td style={{ width: '100px' }}>
                      <img src={item.productImage} alt={item.productImage} className="img-fluid" />
                    </td>
                    <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                      {' '}
                      {item.productName}
                    </td>
                    <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                      {item.productQuantity}
                    </td>
                    <td
                      style={{ verticalAlign: 'middle', width: '100px' }}
                      className="font-weight-bold text-muted"
                    >
                      $
                      {(Math.round(item.productQuantity * item.productPrice * 100) / 100).toFixed(
                        2
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tbody className="border-0">
                <tr>
                  <td className="border-0"></td>
                  <td className="border-0"></td>
                  <td className="border-0">SubTotal</td>
                  <td className="border-0">AU ${SubTotal.toFixed(2)}</td>
                </tr>
                <tr>
                  <td className="border-0"></td>
                  <td className="border-0"></td>
                  <td className="border-0">Shipping</td>
                  <td className="border-0">
                    {locationState.order.shippingFee === 0
                      ? 'Free'
                      : 'AU $' + locationState.order.shippingFee.toFixed(2)}
                  </td>
                </tr>

                {locationState.order.coupon && discount !== undefined && (
                  <React.Fragment>
                    <tr>
                      <td className="border-0"></td>
                      <td className="border-0"></td>
                      <td className="border-0">Discount</td>
                      <td className="border-0">
                        {locationState.order.coupon.isPercent ? '%' : 'AU $'}
                        {locationState.order.coupon.amount}
                      </td>
                    </tr>
                    <tr>
                      <td className="border-0"></td>
                      <td className="border-0"></td>
                      <td className="border-0">Discount Applied</td>
                      <td className="border-0 text-danger"> - AU ${discount.toFixed(2)}</td>
                    </tr>
                  </React.Fragment>
                )}

                <tr>
                  <td className="border-0"></td>
                  <td className="border-0"></td>
                  <td className="border-0">Total</td>
                  <td className="border-0">AU ${total.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </div>
      <div>
        <p className="text-center" style={{ fontSize: '20px' }}>
          {locationState.order.orderStatus === 'Confirmed'
            ? 'We will get your order ready for pick up.'
            : 'We will process your order and let you know when your products will be delivered via email.'}
        </p>
        <p
          className="text-center"
          style={{ fontSize: '20px', marginLeft: '10%', marginRight: '10%' }}
        >
          Email us at
          <span>
            {' '}
            <a style={{ color: 'rgb(236,23,79)' }} href="mailto:someone@example.com">
              sales@harvestimevic.com.au
            </a>{' '}
          </span>
          with any questions, suggestions, or your favorite Frozberries product.
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  orders: state.orders,
});

export default connect(mapStateToProps, { resetOrder, resetCoupon })(OrderReceived);
